import NewSuccessView from '../../../NewSuccessView';
import { useMultiTierCheckout } from '../../context';
import {
  useGetMyEligibleOffers,
  useGetTicketInfoRequired
} from '../../../../../hooks';

const SuccessStep = () => {
  const {
    data: {
      event,
      checkoutSession: { checkoutSession }
    },
    onClose,
    onViewEventPostCheckout
  } = useMultiTierCheckout();

  const { data: ticketInfoRequired, refetch: refetchTicketInfo } =
    useGetTicketInfoRequired(event._id);

  const { data: offers } = useGetMyEligibleOffers(event._id);

  return (
    <NewSuccessView
      event={event}
      ticketInfoRequired={ticketInfoRequired}
      onClose={onClose}
      isEligibleForOffers={offers?.length > 0}
      price={checkoutSession.total.toFixed(2)}
      onFillRequestedInfoSuccess={refetchTicketInfo}
      onClickViewEvent={() => onViewEventPostCheckout?.()}
    />
  );
};

export default SuccessStep;
